import React, { useState } from 'react';

import { Button, Group, Paper, Title, useMantineTheme } from '@mantine/core';
import { IconDots } from '@tabler/icons-react';
import LogWorkForm from 'components/LogWorkForm';

const LogWorkCard = (): JSX.Element => {
  const theme = useMantineTheme();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Paper radius='lg' p='md' shadow='md' withBorder>
      <Group position='apart' pb='xs'>
        <Title order={4}>Log Work Hours</Title>
        <Group position='right'>
          {isOpen ? (
            <Button variant='light' compact onClick={() => setIsOpen(false)}>
              Close
            </Button>
          ) : (
            <Button compact onClick={() => setIsOpen(true)}>
              Expand
            </Button>
          )}
        </Group>
      </Group>
      {isOpen ? (
        <LogWorkForm />
      ) : (
        <Group position='center'>
          <IconDots color={theme.colors.gray[5]} />
        </Group>
      )}
    </Paper>
  );
};

export default LogWorkCard;
